export default __webpack_public_path__ + "static/icon-transparency-traceability-ed77cbcb1edb3ca981feeee1a7860148.svg";